<template>
  <div>
    <component v-bind:is="styleColor"> </component>
  </div>
</template>
<script type="text/ecmascript-6">
  import IndexNormal from './components/index-normal.vue';
  import IndexBlue from './components/index-blue.vue';
  import IndexBlack from './components/index-black.vue';
  export default {
    name: 'login',
    components: {
      IndexNormal,
      IndexBlue,
      IndexBlack
    },
    data () {
      return {
        styleColor: ''
      }
    },
    computed: {
      objApi() {
        return this.$store.getters.objApi
      }
    },
    created() {
      console.log(this.objApi.styleColor);
      // if (this.objApi.styleColor === 'blue') {
      //   this.styleColor = 'IndexBlue';
      // } else if (this.objApi.styleColor === 'black') {
      //   this.styleColor = 'IndexBlack';
      // } else {
        this.styleColor = 'IndexNormal';
      // }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/login/index.vue